import { IObject } from '../types';

export interface IStorageConfig {
  [name: string]: any;
}

export interface IStateStorageConfig {
  [name: string]: string[];
}

export const namespace = 'state';

export const storageAvailable = (storage: Storage) => {
  try {
    if (storage) {
      const test = '__storage_test__';
      storage?.setItem(test, test);
      storage?.removeItem(test);
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const getStorage = <T = IObject>(key: string, storage: Storage): T => {
  const data = storage.getItem(`${namespace}.${key}`);
  const parsed: T = data && JSON.parse(data);
  return parsed;
};

export const setStorage = (key: string, data: Record<string, any>, storage: Storage): void => {
  const existing = storage.getItem(`${namespace}.${key}`);
  const parsed = existing && JSON.parse(existing);

  const newData = { ...parsed, ...data };
  storage.setItem(`${namespace}.${key}`, JSON.stringify(newData));
};

export const clearStorage = (key: string, storage: Storage): void => {
  if (storageAvailable(storage)) {
    storage.removeItem(`${namespace}.${key}`);
  }
};

export const getStateFromStorage = (storageConfig: IStorageConfig, storage: Storage) => {
  const stateData: IObject = {};
  Object.keys(storageConfig).forEach((key: string) => {
    const storageData = JSON.parse(storage.getItem(`${namespace}.${key}`)) || undefined;

    stateData[key] = { ...storageConfig[key], ...storageData };
  });

  return stateData;
};

export const setStorageFromState = (
  state: any,
  stateConfig: IStateStorageConfig,
  storage: Storage
) => {
  Object.keys(stateConfig).forEach((key: string) => {
    const newState: IObject = {};

    stateConfig[key].forEach((item: string) => {
      newState[item] = state[key][item];
    });

    const stateString = JSON.stringify(newState || {});

    if (storage.getItem(`${namespace}.${key}`) !== stateString) {
      storage.setItem(`${namespace}.${key}`, stateString);
    }
  });
};
